import { render, staticRenderFns } from "./ContactDashboardPage.vue?vue&type=template&id=1b1c1e36&"
import script from "./ContactDashboardPage.vue?vue&type=script&lang=js&"
export * from "./ContactDashboardPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports